import { render } from "./ScreenRecording.vue?vue&type=template&id=24016d88&scoped=true"
import script from "./ScreenRecording.vue?vue&type=script&lang=js"
export * from "./ScreenRecording.vue?vue&type=script&lang=js"

import "./ScreenRecording.vue?vue&type=style&index=0&id=24016d88&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24016d88"]])

export default __exports__